import React from 'react';
import { useTable } from '../TableContext';
import { TableRow } from './TableRow';
import { TableSubComponent } from './TableSubComponent';
import { TableRowSpacer } from './TableRowSpacer';

export function TableBody<T>() {
  const { table, row, expansion } = useTable<T>();
  const rows = table.getRowModel().rows;

  return (
    <tbody>
      {rows.map((bodyRow, index) => (
        <React.Fragment key={bodyRow.id}>
          {row?.spacer && <TableRowSpacer />}

          <TableRow
            row={bodyRow}
            displayIndex={index}
            to={row?.linkTo?.(bodyRow)}
            className={
              typeof row?.className === 'function'
                ? row.className({ index, row: bodyRow })
                : row?.className
            }
            onClick={
              row?.onClick
                ? (event) => row.onClick?.(bodyRow, event)
                : undefined
            }
          />

          {expansion?.enabled && (
            <TableSubComponent
              row={bodyRow}
              toggle={{
                position: expansion.toggle?.position,
                render: expansion.toggle?.render,
              }}
            >
              {expansion.renderContent({
                row: bodyRow,
                isExpanded: bodyRow.getIsExpanded(),
                onToggle: () => bodyRow.toggleExpanded(),
              })}
            </TableSubComponent>
          )}
        </React.Fragment>
      ))}
    </tbody>
  );
}
